import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Overview = Loader(lazy(() => import('src/content/overview')));

// Dashboards

const Tasks = Loader(lazy(() => import('src/content/dashboards/Tasks')));

// Applications

const Messenger = Loader(
  lazy(() => import('src/content/applications/Messenger'))
);

const MessengerStaff = Loader(
  lazy(() => import('src/content/applications/MessengerStaff'))
);
const MessengerClaims = Loader(
  lazy(() => import('src/content/applications/claimMessanger'))
);
const MessengerALL = Loader(
  lazy(() => import('src/content/applications/Staff/MessengerAll'))
);

const Staff = Loader(lazy(() => import('src/content/applications/Staff')));

const RCollaborationsRecived = Loader(
  lazy(() => import('src/content/applications/RCollaborationsRecived'))
);
const AvailableStaffPage = Loader(
  lazy(() => import('src/content/applications/AvailableStaff'))
);
const JobPosts = Loader(
  lazy(() => import('src/content/applications/jobPosts'))
);
const CollaborationsSent = Loader(
  lazy(() => import('src/content/applications/CollaborationsSent'))
);
const ClaimsHistory = Loader(
  lazy(() => import('src/content/applications/ClaimsHistory'))
);

const Claims = Loader(lazy(() => import('src/content/applications/Claims')));
const Manager = Loader(lazy(() => import('src/content/applications/Manager')));
const ClaimManager = Loader(
  lazy(() => import('src/content/applications/ClaimManager'))
);
const Responsible = Loader(
  lazy(() => import('src/content/applications/Responsible'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);

const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);

const CompanySettings = Loader(
  lazy(() => import('src/content/applications/Company/settings'))
);

const CompanyLostItems = Loader(
  lazy(() => import('src/content/applications/Company/lost-items'))
);

const CompanyRestaurantMenu = Loader(
  lazy(() => import('src/content/applications/Company/restaurant-menu'))
);

const CompanyReservations = Loader(
  lazy(() => import('src/content/applications/Company/reservations'))
);

const CompanyServiceRequests = Loader(
  lazy(() => import('src/content/applications/Company/service-requests'))
);

const StaffRatings = Loader(
  lazy(() => import('src/content/applications/Company/staff-ratings'))
);
const StaffRatingsAdmin = Loader(
  lazy(() => import('src/content/applications/Company/staff-ratings-admin'))
);
const Attendance = Loader(
  lazy(() => import('src/content/applications/Company/attendance'))
);

const CompanyFavoriteClients = Loader(
  lazy(() => import('src/content/applications/Company/favorite-clients'))
);


// Components

const StaffTable = Loader(
  lazy(() => import('src/content/applications/Staff/StaffTable'))
);

const CollaborationsTable = Loader(
  lazy(() =>
    import('src/content/applications/CollaborationsSent/collaborationsTable')
  )
);
const CollaborationsReceivedTable = Loader(
  lazy(() =>
    import(
      'src/content/applications/RCollaborationsRecived/collaborationsReceivedTable'
    )
  )
);
const ClaimsHistoryTable = Loader(
  lazy(() =>
    import('src/content/applications/ClaimsHistory/ClaimsHistoryTable')
  )
);
const ClaimsTable = Loader(
  lazy(() => import('src/content/applications/Claims/ClaimsTable'))
);
const ClaimManagersTable = Loader(
  lazy(() => import('src/content/applications/ClaimManager/ClaimManagerTable'))
);
const ManagersTable = Loader(
  lazy(() => import('src/content/applications/Manager/ManagerTable'))
);
const ResponsibleTable = Loader(
  lazy(() => import('src/content/applications/Responsible/ResponsibleTable'))
);
const JobPostsTable = Loader(
  lazy(() => import('src/content/applications/jobPosts/JobPostsTable'))
);

const Buttons = Loader(
  lazy(() => import('src/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('src/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('src/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(
  lazy(() => import('src/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('src/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('src/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const ClaimDetails = Loader(
  lazy(() => import('src/content/applications/Claims/details'))
);

const DetailsStaff = Loader(
  lazy(() => import('src/content/applications/Staff/DetailsStaff/indexS'))
);
const AllRequests = Loader(
  lazy(() => import('src/content/applications/Staff/AllRequests'))
);
const GroupChat = Loader(
  lazy(() => import('src/content/applications/Staff/GroupChat'))
);
const ForgetPassword = Loader(
  lazy(() => import('src/content/ForgetPassword/ForgotPassword'))
);
const ResetPassword = Loader(
  lazy(() => import('src/content/ForgetPassword/ResetPassword'))
);
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const routes = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Overview />
      },
      {
        path: 'forgetPassword',
        element: <ForgetPassword />
      },
      {
        path: 'resetpassword',
        element: <ResetPassword />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },

  {
    path: 'dashboards',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="tasks" replace />
      },
      {
        path: 'tasks',
        element: <Tasks />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="profile" replace />
      },
      {
        path: 'company',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <CompanySettings />
          },
          {
            path: 'lost-items',
            element: <CompanyLostItems />
          },
          {
            path: 'restaurant-menu',
            element: <CompanyRestaurantMenu />
          },
          {
            path: 'reservations',
            element: <CompanyReservations />
          },
          {
            path: 'service-requests',
            element: <CompanyServiceRequests />
          },
          {
            path: 'favorite-clients',
            element: <CompanyFavoriteClients />
          },
        ]
      },

      {
        path: 'claims',
        element: <Claims />,
        children: [
          {
            path: '',
            element: <ClaimsTable />
          },

          {
            path: 'details/:id',
            element: <Messenger />
          },
          {
            path: 'detailsClaim/:id',
            element: <ClaimDetails />
          },
          {
            path: 'claimshistory',
            element: <ClaimsHistoryTable />
          }
        ]
      },

      {
        path: 'ClaimsHistory',
        element: <ClaimsHistory />,
        children: [
          {
            path: '',
            element: <ClaimsHistoryTable />
          },
          {
            path: 'detailsClaim/:id',
            element: <ClaimDetails />
          }
        ]
      },
      {
        path: 'messenger',
        element: <MessengerClaims />
      },
      {
        path: 'staff-ratings',
        element: <StaffRatings />
      },
      {
        path: 'staff-ratings/admin',
        element: <StaffRatingsAdmin />
      },
      {
        path: 'attendance',
        element: <Attendance />
      },
      {
        path: 'Managers',
        element: <Manager />,
        children: [
          {
            path: '',
            element: <ManagersTable />
          }
        ]
      },
      {
        path: 'ClaimManagers',
        element: <ClaimManager />,
        children: [
          {
            path: '',
            element: <ClaimManagersTable />
          }
        ]
      },
      {
        path: 'Responsibles',
        element: <Responsible />,
        children: [
          {
            path: '',
            element: <ResponsibleTable />
          }
        ]
      },
      {
        path: 'ReceivedCollab',
        element: <RCollaborationsRecived />,
        children: [
          {
            path: '',
            element: <CollaborationsReceivedTable />
          }
        ]
      },
      {
        path: 'SentCollab',
        element: <CollaborationsSent />,
        children: [
          {
            path: '',
            element: <CollaborationsTable />
          }
        ]
      },
      {
        path: 'JobPosts',
        element: <JobPosts />,
        children: [
          {
            path: '',
            element: <JobPostsTable />
          }
        ]
      },
      {
        path: 'AvailableStaff',
        element: <AvailableStaffPage />
      },
      {
        path: 'staff',
        element: <Staff />,
        children: [
          {
            path: '',
            element: <StaffTable />
          },
          {
            path: 'detailS/:id',
            element: <MessengerStaff />
          },
          {
            path: 'detailsStaff/:id',
            element: <DetailsStaff />
          },
          {
            path: 'requests',
            element: <AllRequests />
          },
          {
            path: 'group-chat',
            element: <GroupChat />
          },

          {
            path: 'messenger',
            element: <MessengerALL />
          }
        ]
      },

      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="settings" replace />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },

  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;
